import { useQuery } from '@tanstack/react-query';

import { bopsApi } from '@Network';

const storeKey = (retailer: string, locationCode: string) => `${retailer}:${locationCode}`;

const useScheduleStoreAssignments = (scheduleId: string, enabled: boolean) =>
  useQuery({
    queryKey: ['schedule-store-assignments', scheduleId],
    queryFn: () => bopsApi.getScheduleStoreAssignmentsForSchedule(scheduleId),
    enabled,
  });

const useActiveStoreNames = (retailer: string | null, enabled: boolean) =>
  useQuery({
    queryKey: ['stores', 'active-names', retailer],
    queryFn: async () => {
      const stores = await bopsApi.getAllStores(retailer ?? undefined);
      return Object.fromEntries(
        stores.map((store) => [storeKey(store.retailer, store.location_code), store.name] as const),
      );
    },
    enabled,
  });

export { storeKey, useActiveStoreNames, useScheduleStoreAssignments };
